<template>
	<div class="login-page-field" extension-name="login-input-field">

		<!-- the field label -->
		<label class="login-page-field-label" v-if="!!value">
			{{ title }}
		</label>
		<label class="login-page-field-label" v-else>
		</label>

		<!-- the input field and the icon -->
		<div class="input-field">
			<input :type="type" :value="value" @input="textChanged" :placeholder="placeholder"
				   @focus="$emit('focus')"
				   @blur="$emit('blur')"
				   @keyup.enter.prevent.stop="$emit('enter')"
				   :disabled="disabled">
			<span :class="validationStatusClass"></span>
		</div>

		<!-- show the password strength when needed -->
		<div class="login-page-field-password-strength"
			 v-if="value && showPasswordStrength && !showErrorMessage && passwordStrengthState">
			<div v-for="eachState in numberOfPasswordStrengthStates"
				  :style="{'background-color': passwordStrengthState.color}"
					class="login-page-field-password-strength-bar">
			</div>
			<br>
			<span class="login-page-field-password-strength-label">
				{{'LoginPageField.PasswordStrengthLabel' | translate}}
			</span>
			<span class="login-page-field-password-strength-value"
				  :style="{'color': passwordStrengthState.color}">
				{{ passwordStrengthState.msg }}
			</span>
		</div>

		<!-- show an error message when there is one -->
		<div class="login-page-field-error-message" a_id="login-page-field-error-message" v-if="showErrorMessage">
			{{ errorMessage }}
		</div>

	</div>
</template>

<script>
	import PasswordStrengthService from '../services/PasswordStrengthService';

	export default {
		name: "LoginPageField",
		props: {
			"title" : {
				type: String
			},
			"type" : {
				type: String,
				default: "text"
			},
			"value" : {
				type: String
			},
			"errorMessage" : {
				type: String
			},
			"showErrorMessage" : {
				type: Boolean,
				default : false
			},
			"validateFunc" : {
				type: Function,
				default: this.validateNotEmpty
			},
			"placeholder" : {
				type: String,
				default: ""
			},
			"imageType" : {
				type: String,
				default: "user"
			},
			"showPasswordStrength" : {
				type: Boolean,
				default: false
			},
			"disabled": {
				type: Boolean,
				default: false
			},
			"inputId": {
				type: String,
				default: ""
			}
		},
		methods: {
			textChanged(evt){
				this.$emit("input", evt.target.value);
			},
			validate(val){
				// use passed validateFunc if supplied
				if(this.validateFunc && typeof this.validateFunc == 'function')
					return this.validateFunc(val);
				// check not empty
				return !!val && val.toString().trim().length > 0;
			},
		},
		computed: {
			validationStatusClass(){
				if(this.showErrorMessage ||
					(this.showPasswordStrength && this.passwordStrengthWeight < 5 && this.value)) {
					return "login-icon invalidClass";
				}
				if(!this.value || !this.value.toString().trim().length) {
					return "login-icon emptyClass " + "emptyClass_" + this.imageType;
				}
				if(this.validate(this.value)){
					return "login-icon validClass";
				} else {
					return "login-icon invalidClass";
				}
			},
			passwordStrengthState(){
				PasswordStrengthService.setPassword(this.value);
				return PasswordStrengthService.getState();
			},
			numberOfPasswordStrengthStates(){
				PasswordStrengthService.setPassword(this.value);
				return parseInt(PasswordStrengthService.getNumberOfStates());
			},
			passwordStrengthWeight(){
				PasswordStrengthService.setPassword(this.value);
				return parseInt(PasswordStrengthService.getWeight());
			}
		},
		watch: {
			passwordStrengthWeight(newStrength){
				if(newStrength === 5){
					this.$emit('passwordStrong', true)
				} else {
					this.$emit('passwordStrong', false)
				}
			}
		},
		mounted() {
			if(this.inputId) {
				let input = this.$el.querySelector('input');
				input.id = this.inputId;
				input.name = this.inputId;
			}
		}
	}
</script>

<style lang="scss">
	@import '../sass/loginPageField.scss';
</style>



// WEBPACK FOOTER //
// src/app/LoginPageField.vue